export const isPrimitive = what => {
  const type = typeof what;
  return what === null || !(type === 'object' || type === 'function');
};

export const isObject = what => !(isPrimitive(what) || Array.isArray(what));
